// extracted by mini-css-extract-plugin
export default {"newVersion":"NewVersion_newVersion__kN-wS"};